import type { OfflineAccess } from "~/utilities/offlineDownload"

// Collection of simple localStorage wrappers, so we don't have to repeat (and potentially mistype) storage keys.

export function useVippsCheckoutSessionId() {
  return useLocalStorage<string | null>("session_id", null)
}

export function useDeviceKey() {
  return useLocalStorage<string>("deviceKey", () => Math.random().toString(36).substring(2))
}

export function useFeatureFlagEnabled() {
  return useLocalStorage<boolean>("isFeatureEnabled", false)
}

export function useLastActiveProduct() {
  return useLocalStorage<string | null>("lastActiveProduct", null)
}

export function useOfflineAccess() {
  return useLocalStorage<OfflineAccess>("offline-access", "not-available")
}

export function useVippsRedirectPath() {
  return useLocalStorage<string | null>("vipps-redirect-from-path", null)
}
